import React, { useRef, useState } from 'react'

import { toast } from 'react-toastify'

import { showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { Box, Button, Flex, Image, Input, Link, Text } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import useAuth from '../../useAuth'

const RequestPasswordResetForm = () => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [email, setEmail] = useState('')
  const emailRef = useRef()

  const dispatch = useDispatch()
  const { useRequestPasswordReset } = useAuth()
  const requestPasswordReset = useRequestPasswordReset()

  const handleSubmit = async () => {
    const emailValue = emailRef.current.value || ''

    if (emailValue === '') {
      toast.error('Please enter your email.')
      return
    }

    try {
      dispatch(showLoadingOverlay)
      await requestPasswordReset.mutateAsync({ email: emailValue })
      setIsSuccess(true)
      setEmail(emailValue)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(showLoadingOverlay)
    }
  }

  const handleResendRecoveryLink = () => {
    setEmail('')
    setIsSuccess(false)
  }

  return (
    <Flex direction="column" bg="white" p={[6, 12]} minW={[0, 500]} alignItems={'center'} gap="3">
      <Image
        w="150px"
        objectFit="cover"
        src={
          // eslint-disable-next-line max-len
          'https://www.siemens-home.bsh-group.com.hk/store/medias/sys_master/root/h63/hcd/10563534323742/GL-SIE-Logo-Siemens-Petrol-RGB-BSH-Reshape-2021.png'
        }
      />

      <Text fontSize="xl">Can&apos;t Login ?</Text>

      {!isSuccess && (
        <>
          <Box alignSelf={'start'} w="100%" mt="5">
            <Text fontSize={'sm'}>We&apos;ll send a recovery link to</Text>
            <Input ref={emailRef} color="blackAlpha.600" type={'email'} placeholder={'Email'} />
          </Box>
          <Button bg="#099d9d" color="white" w="100%" onClick={handleSubmit}>
            Send
          </Button>
        </>
      )}

      {isSuccess && (
        <>
          <Box alignSelf={'start'} w="100%" mt="5">
            <Text fontSize={'sm'}>We sent a recovery link to you at </Text>
            <Text fontSize="lg">{email}</Text>
          </Box>
        </>
      )}
      <Flex gap="3" mt="8">
        <Link color="#099d9d" href="/auth/login">
          Go back to Login
        </Link>

        {isSuccess && (
          <Box color="#099d9d" _hover={{ cursor: 'pointer' }} onClick={handleResendRecoveryLink}>
            Resend recovery link
          </Box>
        )}
      </Flex>
    </Flex>
  )
}
export default RequestPasswordResetForm
